import { useEffect, useState } from 'react';

import { useTranslation } from '@cms/i18n/client';
import styles from '@common/atoms/SearchBox/SearchBox.module.scss';
import { SearchIcon } from '@common/svg/icons/components/SearchIcon';

export interface Props {
    currentSearch: string;
    onSubmit: (SearchText: string) => any;
}

export const SearchBox = ({ currentSearch, onSubmit }: Props) => {
    const __components = useTranslation('components').t;
    const [value, setValue] = useState<string>(currentSearch);

    const interval: number = 750; //ms

    const handleTimeOut = function () {
        if (value !== currentSearch) {
            onSubmit(value);
        }
    };

    let timer: NodeJS.Timeout;

    useEffect(() => {
        setValue(currentSearch);
    }, [currentSearch]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        timer = setTimeout(handleTimeOut, interval);
    }, [value]);

    return (
        <div className={styles.SearchBox}>
            <SearchIcon />
            <input
                type="search"
                value={value}
                name="search"
                autoComplete="off"
                placeholder={__components('SearchBox.placeholder')}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onSubmit(value);
                    }
                }}
                onChange={(e) => {
                    const newValue = e.target.value;
                    clearTimeout(timer);
                    if (newValue !== value) {
                        setValue(newValue);
                    }
                }}
            />
        </div>
    );
};
